import createIcon from '../../createIcon';

/**
 * @component @name TypeSpecimen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNCA2SDJWMjBDMiAyMS4xIDIuOSAyMiA0IDIySDE4VjIwSDRWNloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAySDhDNi45IDIgNiAyLjkgNiA0VjE2QzYgMTcuMSA2LjkgMTggOCAxOEgyMEMyMS4xIDE4IDIyIDE3LjEgMjIgMTZWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTE2LjYzIDE0LjVMMTUuODMgMTIuMkgxMi4yTDExLjM4IDE0LjVIOS44MUwxMy4xOSA1LjVIMTQuOEwxOC4xOCAxNC41SDE2LjYzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzLjk2IDcuMTdMMTIuNjUgMTAuODlIMTUuMzRMMTQuMDQgNy4xN0gxMy45NloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TypeSpecimen = createIcon('TypeSpecimen', [
  ['path', { d: 'M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6Z', key: '7m1wx6' }],
  [
    'path',
    {
      d: 'M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM16.63 14.5L15.83 12.2H12.2L11.38 14.5H9.81L13.19 5.5H14.8L18.18 14.5H16.63Z',
      key: 'p9qwx6',
    },
  ],
  ['path', { d: 'M13.96 7.17L12.65 10.89H15.34L14.04 7.17H13.96Z', key: '1h3kvr' }],
]);

export default TypeSpecimen;
